import * as React from 'react';
import { forwardRef } from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgPeople24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 10.5C18.5712 10.5 20.2501 8.82107 20.2501 6.75C20.2501 4.67893 18.5712 3 16.5001 3C14.4291 3 12.7501 4.67893 12.7501 6.75C12.7501 8.82107 14.4291 10.5 16.5001 10.5ZM16.5001 12C13.0229 12 10.0093 14.4543 9.32732 17.864C9.15805 18.7104 9.80539 19.5 10.6685 19.5H22.3317C23.1949 19.5 23.8422 18.7104 23.6729 17.864C22.991 14.4543 19.9773 12 16.5001 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3593 13.7038C9.32514 13.0534 8.10538 12.6818 6.81544 12.6818C3.65435 12.6818 0.914652 14.913 0.29471 18.0127C0.140829 18.7822 0.729321 19.5 1.51396 19.5H8.73572C8.37546 18.9917 8.21233 18.3401 8.34677 17.6679C8.65161 16.1437 9.36543 14.7881 10.3593 13.7038ZM6.81544 11.3182C8.69823 11.3182 10.2245 9.79188 10.2245 7.90909C10.2245 6.0263 8.69823 4.5 6.81544 4.5C4.93265 4.5 3.40635 6.0263 3.40635 7.90909C3.40635 9.79188 4.93265 11.3182 6.81544 11.3182Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeople24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=People24.svg.js.map
